<template>
  <div>
    <v-card v-if="formActive">
      <v-card-title>
        <span class="headline">Новая точка учета</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form">
            <v-layout wrap>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  v-model="editedItem.name"
                  :rules="pointAddRules"
                  label="Наименование"
                  required
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  v-model="editedItem.point_number"
                  :rules="pointAddRules"
                  label="Идентификатор Точки учёта"
                  required
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-autocomplete
                  v-model="editedItem.customer_id"
                  :items="customers"
                  :menu-props="{maxHeight:'auto'}"
                  item-text="name"
                  item-value="customer_id"
                  label="Абонент"
                  no-data-text="Нет доступных абонентов"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  v-model="editedItem.address"
                  :rules="pointAddRules"
                  label="Адрес"
                  required
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  v-model="editedItem.remark"
                  label="Примечание"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          @click.native="save"
        >
          Сохранить
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click.native="close"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-layout
      v-else-if="loading"
      align-center
      class="loading-indicator"
      justify-center
    >
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
      />
    </v-layout>
    <v-card
      v-show="!formActive && !firstLoading"
      class="points-card"
    >
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          hide-details
          label="Поиск по наименованию и идентификатору ТУ"
          single-line
        />
        <v-spacer />
        <v-btn
          color="primary"
          fab
          title="Добавить точку учёта"
          @click="addPoint"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :footer-props="{
          itemsPerPageText: 'Число ТУ на странице',
          itemsPerPageOptions: [25, 50]
        }"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="serverItemsLength"
        dense
        fixed-header
        no-data-text="Нет точек учёта для отображения"
      >
        <tr
          slot="item"
          slot-scope="props"
        >
          <td>{{ props.item.name }}</td>
          <td>
            <v-icon
              v-if="!props.item.counter_id"
              color="red"
              title="Счётчик не установлен"
            >
              fas fa-ban
            </v-icon>
          </td>
          <td align="center">
            <v-tooltip
              v-if="props.item.represents != null"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="teal"
                  fab
                  outlined
                  x-small
                  v-on="on"
                >
                  {{ props.item.represents.length }}
                </v-btn>
              </template>
              <div
                v-for="represent in props.item.represents"
                :key="represent.represent_id"
              >
                Объект {{ represent.name }}
              </div>
            </v-tooltip>
            <v-btn
              v-else
              color="teal"
              fab
              outlined
              x-small
            >
              0
            </v-btn>
          </td>
          <td>{{ props.item.point_number }}</td>
          <td>{{ props.item.customer ? props.item.customer.name : '' }}</td>
          <td>{{ props.item.address }}</td>
          <td class="justify-center">
            <span class="action-btns">
              <v-btn
                :to="`/points/${props.item.point_id}/edit`"
                icon
                title="Редактировать"
              >
                <v-icon color="grey">edit</v-icon>
              </v-btn>
              <v-btn
                :to="`/points/${props.item.point_id}/counters`"
                icon
                title="Счетчики"
              >
                <v-icon color="grey">fas fa-tachometer-alt</v-icon>
              </v-btn>
              <v-btn
                :to="`/points/${props.item.point_id}/scheduler`"
                icon
                title="Расписание"
              >
                <v-icon color="grey">fas fa-clock</v-icon>
              </v-btn>
              <v-btn
                icon
                title="Удалить"
                @click="deleteItem(props.item)"
              >
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </span>
          </td>
        </tr>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'

const API_URL = 'points'
export default {
  name: 'Point',
  data () {
    return {
      search: '',
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      hasOptionsBeenWatched: false,
      dialog: false,
      serverItemsLength: 0,
      formActive: false,
      items: [],
      headers: [
        { text: 'Наименование', value: 'name' },
        { text: '', value: 'has_counter' },
        {
          text: 'Число объектов принадлежности',
          sortable: false,
          align: 'center',
          value: 'point_represents_number' },
        { text: 'Идентификатор', value: 'point_number' },
        { text: 'Абонент', value: 'customer__name' },
        { text: 'Адрес', value: 'address' },
        { text: '', sortable: false, value: '' }
      ],
      editedItem: {
        point_id: '',
        point_number: '',
        customer: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: ''
      },
      defaultItem: {
        point_id: '',
        point_number: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: ''
      },
      customers: [],
      showErrorMsg: false,
      showError: false,
      pointAddRules: [
        v => !!v || 'Заполните это поле!'
      ],
      getTimer: '',
      searchTimer: '',
      deleteTimer: ''
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
      val && this.getCustomersApi()
    },
    options: {
      handler () {
        this.getItemsApiTimer()
      },
      deep: true
    },
    search (val) {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.options.page = 1
        this.getItemsApiTimer()
      }, 500)
    }
  },
  methods: {
    getItemsApi () {
      this.loading = true
      axios.get(`/api/${API_URL}/?` +
        `per_page=${this.options.itemsPerPage}` +
        `&page=${this.options.page}` +
        `&ordering=` +
          (this.options.sortDesc[0] ? '-' : '') +
          (this.options.sortBy[0] || '') +
        `&search=${this.search}`
      )
        .then((response) => {
          this.items = response.data.results
          this.serverItemsLength = response.data.count
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.firstLoading = false
          this.loading = false
        })
    },
    getItemsApiTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getItemsApi()
      }, 100)
    },
    getCustomersApi () {
      axios.get(`/api/customers/`)
        .then((response) => {
          this.customers = response.data.results
          console.log(this.customers)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addItemApi () {
      this.axios.post(`/api/${API_URL}/`, this.editedItem)
        .then(() => {
          this.getItemsApiTimer()
          this.close()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    deleteItemApi (item) {
      this.axios.delete(`/api/${API_URL}/${item.point_id}`)
        .then(() => {
          this.items.splice(
            this.items.indexOf(item), 1
          )
          clearTimeout(this.deleteTimer)
          this.deleteTimer = setTimeout(() => {
            this.items.length || this.options.page === 1 || this.options.page--
            this.getItemsApiTimer()
          }, 1000)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    validate () {
      if (this.$refs.form.validate()) {
        return true
      }
    },
    deleteItem (item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteItemApi(item)
      }
    },
    addPoint () {
      this.formActive = true
      this.getCustomersApi()
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
      this.formActive = false
    },
    save () {
      if (this.validate()) {
        this.addItemApi()
        this.formActive = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-btns {
    white-space: nowrap;
  }
  .v-btn--floating .v-btn__content {
    height: inherit;
  }
  .v-card.points-card {
    position: unset;
    .v-data-table {
      position: absolute;
      height: calc(100% - 88px);
      right: 0;
      left: 0;
    }
    .v-data-table__wrapper {
      max-height: calc(100% - 59px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/points/Points.vue